import apiClient from '@u/apiClient'
import FetchDossierGuestSuiteController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierGuestSuiteController'
import CreateDossierGuestSuiteController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/CreateDossierGuestSuiteController'
import UpdateDossierGuestSuiteController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/UpdateDossierGuestSuiteController'
import GetGuestSuiteLocationsController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/GetGuestSuiteLocationsController'

export default {
  fetchGuestSuite(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierGuestSuiteController.get({ dossier: payload.dossier_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createGuestSuite(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateDossierGuestSuiteController.post({
            dossier: payload.dossier_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateAutoCreate(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierGuestSuiteController.put({
            dossier: payload.dossier_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getGuestSuiteLocations(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetGuestSuiteLocationsController.post(),
          { guest_suite_token: payload.guest_suite_token },
          { skipValidationToast: true }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
